var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo, useState } from 'react';
import { AssignmentStatusesByFilter, } from '../../../../constants/filters';
import { usePartialItemsLoad } from '../../../../hooks/usePartialItemsLoad';
import { COMPLETED_ASSIGNMENTS_PER_PAGE, addTitleRowsIntoAssignments, groupAssignmentsByTableFilters, } from './tableConfig';
export var useAssignmentsTableData = function (_a) {
    var assignments = _a.assignments, filter = _a.filter;
    var _b = usePartialItemsLoad(COMPLETED_ASSIGNMENTS_PER_PAGE), completedAssignmentsShowed = _b.itemsCount, setCompletedAssignmentsCount = _b.loadItems;
    var _c = useState(assignments), currentAssignments = _c[0], setCurrentAssignments = _c[1];
    var filteredAssignments = useMemo(function () {
        return filter
            ? currentAssignments.filter(function (_a) {
                var status = _a.status;
                return AssignmentStatusesByFilter[filter].includes(status);
            })
            : currentAssignments;
    }, [currentAssignments, filter]);
    var groupedAssignments = useMemo(function () { return groupAssignmentsByTableFilters(filteredAssignments); }, [filteredAssignments]);
    var isAllCompletedShowed = useMemo(function () { return groupedAssignments.Ended.length <= completedAssignmentsShowed; }, [groupedAssignments, completedAssignmentsShowed]);
    var _d = useState(!isAllCompletedShowed), showLoadMore = _d[0], setShowLoadMore = _d[1];
    var slicedGroupedAssignments = useMemo(function () {
        var _a;
        if (!isAllCompletedShowed) {
            return __assign(__assign({}, groupedAssignments), (_a = {}, _a["Ended" /* Ended */] = groupedAssignments.Ended.slice(0, completedAssignmentsShowed), _a));
        }
        return groupedAssignments;
    }, [completedAssignmentsShowed, groupedAssignments, isAllCompletedShowed]);
    var tableData = useMemo(function () { return addTitleRowsIntoAssignments(slicedGroupedAssignments); }, [slicedGroupedAssignments]);
    useEffect(function () {
        if (isAllCompletedShowed && showLoadMore)
            setShowLoadMore(false);
    }, [isAllCompletedShowed, showLoadMore]);
    return {
        tableData: tableData,
        showLoadMore: !isAllCompletedShowed,
        loadMore: setCompletedAssignmentsCount,
        updateAssignments: setCurrentAssignments,
        currentAssignments: currentAssignments,
        filteredAssignments: filteredAssignments,
    };
};
